export class LocationService {
	constructor($location, $window) {
		'ngInject';
		this.$location = $location;
		this.$window = $window;
	}

	/**
	 * Turns a URL's search string into an object
	 * @param query String  the search string of a URL (e.g., window.location.search)
	 * @returns Object
	 */
	parseSearchParams(query) {
		return query
			.slice(1)
			.split('&')
			.map(p => p.split('='))
			.reduce((obj, pair) => {
				const [key, value] = pair.map(decodeURIComponent);
				return { ...obj, [key]: value };
			}, {});
	}

	/**
	 * Retrieves window.location.search and parses into JS object
	 * @returns {Object}
	 */
	getNativeSearchParams() {
		if (this.$window.location.search) {
			return this.parseSearchParams(this.$window.location.search);
		} else {
			return {};
		}
	}

	/**
	 * Retrieves Angular's location from $location.search() and returns
	 * @returns {Object}
	 */
	getAngularSearchParams() {
		return this.$location.search();
	}

	/**
	 * Retrieves native and Angular search params. Native search params
	 * are overwritten by and Angular search params with the same key.
	 * @returns {Object}
	 */
	getAllSearchParams() {
		return { ...this.getNativeSearchParams(), ...this.getAngularSearchParams() };
	}
}
